require('../modules/es6.parse-float');
module.exports = require('../modules/_core').parseFloat;



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/es6/parse-float.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/es6/parse-float.js
// module chunks = 0